import React from 'react';
import SettingsComponent from './settings.component';

const Settings = (props) => {
    return <SettingsComponent {...props} />;
};

export default Settings;
